import React, { useState, useCallback, useEffect,useContext } from 'react'
import './AgentWindow.css';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext'
import { Button, Dropdown } from 'react-bootstrap'
import { useTranslation } from "react-i18next";


//                     breakName={this.props.breakName}
//                     breakDurationSec={this.props.breakDurationSec}
//                     breakStartTime={this.props.breakStartTime}
//                     acdState={this.props.acdState}
//                     breakReasons={this.props.breakReasons}
//                     OnBreakStateBtnClicked={this.handleOnBreakStateBtnClicked}
//                     OnAcdBtnClicked={this.handleOnAcdBtnClicked}
//                     handleOndialerStateBtnClicked={this.handleOndialerStateBtnClicked}

const AgentWindow = (props) => {
    //@@@@@@@@@@useStates@@@@@@@@@@
    const alertCtx = useContext(AlertContext)
    const [t] = useTranslation('common')
    let initSelectedBreakState = t('Select break')
    const [selectedBreakState, setSelectedBreakState] = useState(initSelectedBreakState)
    
    //@@@@@@@@@@useCallback@@@@@@@@@@

    const handleOnSelectBreakClicked = useCallback((breakText) => {
        setSelectedBreakState(breakText)
    }, [setSelectedBreakState])

    const OnAcdBtnClicked = props.OnAcdBtnClicked
    const acdState = props.acdState
    const breakName = props.breakName
    const OnBreakStateBtnClicked = props.OnBreakStateBtnClicked
    const handleOnAcdBtnClicked = useCallback(() => {
        if (acdState === 'notConnected') {
            alertCtx.showAlert(t('error'), t('Please connect the extension to the queue'), 'sm')
            return 
        }
        else if (acdState === 'Available') {
            OnAcdBtnClicked('Unavailable')//Sign-Out
        }
        else {
            if (breakName) {
                OnBreakStateBtnClicked('stop', selectedBreakState)
            }
            else {
                OnAcdBtnClicked('Available')
            }
        }
    }, [OnAcdBtnClicked, acdState , OnBreakStateBtnClicked,breakName,selectedBreakState,alertCtx])

    
    const handleOnBreakStateBtnClicked = useCallback(() => {
        if (!breakName) {//start a break
            if (selectedBreakState === initSelectedBreakState) return alertCtx.showAlert(t('error'), t('Select the type of break'), 'sm')
            OnBreakStateBtnClicked('start', selectedBreakState)
        }
        else {//stop a break
            OnBreakStateBtnClicked('stop', selectedBreakState)
        }
    }, [breakName, initSelectedBreakState, OnBreakStateBtnClicked, selectedBreakState,alertCtx])

    useEffect(() => {
        if (!breakName) {
            setSelectedBreakState(initSelectedBreakState)
        }
        else {
            setSelectedBreakState(breakName)
        }

    }, [breakName, initSelectedBreakState])

    //@@@@@@@@@@function@@@@@@@@@@


    let breaksDropDownList = undefined
    if (props.breakReasons) {
        breaksDropDownList = props.breakReasons.map((breakItem, i) => {
            return <Dropdown.Item className='BreaksItem' onClick={() => handleOnSelectBreakClicked(breakItem.breakName)} key={i}>{breakItem.breakName}</Dropdown.Item>
        })
    }
    //AgentQueueDiv
    let AgentQueueDiv = 'AgentQueueDiv'
    let AgentQueueTitle = t('Not in queue')
    if (acdState === 'Available') {
        AgentQueueDiv += ' toGreenColor'
        AgentQueueTitle = t('Available')
    }
    else if (acdState === 'notConnected') {
        AgentQueueDiv += ' toBlackColor'
        AgentQueueTitle = t('Not in queue')
    }
    else {
        AgentQueueDiv += ' toRedColor'
        AgentQueueTitle = t('Unavailable')
    }

    //callsCount
    const callsCount = t('Today calls count',{todayCallsCount:props.todayCallsCount})

    //breakIcon
    let AgentQueueButton = undefined
    if (!breakName) {
        AgentQueueButton = 'far fa-play-circle breakButton'
    }
    else {
        AgentQueueButton = 'far fa-pause-circle breakButton'
    }

    //break seconds timer
    let breakDurationSec = undefined
    let timerSeconds = undefined
    let timerText = undefined
    if (!props.breakName) {
        breakDurationSec = 0
        timerText = 'timerText timerTextNotVisibale'
    }
    else {
        breakDurationSec = parseInt(props.breakDurationSec, 10)
        timerSeconds = new Date(breakDurationSec * 1000).toISOString().substr(11, 8);
        timerText = 'timerText'
    }

    //isDialerActive
    const isDialerActive = props.isDialerActive
    let DialerButtonVariant = 'success'
    const changeAgentDialerState = props.OnchangeAgentDialerState


    if (isDialerActive) {
        DialerButtonVariant = 'success'
    }
    else {
        DialerButtonVariant = 'danger'
    }
    const handleOnChangeAgentDialerStateBtnClicked = useCallback(() => {
        changeAgentDialerState()
    }, [changeAgentDialerState])

    const PbxConnectionStatus = props.PbxConnectionStatus
    let HebPbxConnectionStatus = undefined
    let PbxConnectionStatusDiv = 'PbxConnectionStatusDiv'  //PbxConnectionStatusBtnNotVisibale
    let PbxConnectionStatusButton = 'fas fa-sync-alt PbxConnectionStatusButton'
    if (PbxConnectionStatus === 'connected') {//connected,notConnected,connecting
        HebPbxConnectionStatus = t('Connected to the PBX')
        PbxConnectionStatusDiv += ' toGreenColor'
        PbxConnectionStatusButton += ' PbxConnectionStatusBtnNotVisibale'
    }
    else if (PbxConnectionStatus === 'notConnected') {
        HebPbxConnectionStatus = t('Not connected to the PBX')
        PbxConnectionStatusDiv += ' toRedColor'
    }
    else if (PbxConnectionStatus === 'connecting') {
        HebPbxConnectionStatus = t('Connecting to the PBX')
        PbxConnectionStatusDiv += ' toOrangeColor'
        PbxConnectionStatusButton += ' PbxConnectionStatusBtnNotVisibale'
    }
    if (props.device) HebPbxConnectionStatus = `(${props.deviceShortNum} - ${props.device}) ${HebPbxConnectionStatus}`


    return (
        <div className="agentWindowContainer">
            <div className="row">
                <div className="col-sm-12 col-md-2"></div>
                <div className="col-sm-12 col-md-8">
                    <div className="agentToolbar">
                        <Button title='Enable/Disable Dialer' onClick={handleOnChangeAgentDialerStateBtnClicked} className='DialerButton' variant={DialerButtonVariant}></Button>
                        <div className="BreaksDiv">
                            <p className={timerText}>{timerSeconds}</p>
                            <i className={AgentQueueButton} onClick={handleOnBreakStateBtnClicked}></i>
                            <Dropdown  >
                                <Dropdown.Toggle className="dropDownBreaks" size="sm" variant="secondary" id="dropdown-basic">
                                    {selectedBreakState}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {breaksDropDownList}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className={AgentQueueDiv} onClick={handleOnAcdBtnClicked}>
                            <i className="fas fa-user AgentQueueButton"></i>
                            <p className="AgentQueueTitle">{AgentQueueTitle}</p>
                        </div>

                        <p className="callsCount">{callsCount}</p>
                        <div className={PbxConnectionStatusDiv}>
                            <p className='PbxConnectionStatusTitle'>{HebPbxConnectionStatus}</p>
                            <i className={PbxConnectionStatusButton} onClick={props.OnDialerReConnectBtnClicked}></i>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-2"></div>
            </div>
        </div>
    )
}

export default AgentWindow